<template>
  <v-layout text-center>
    <v-container>
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-toolbar color="blue" dark>
              <v-toolbar-title>Badges</v-toolbar-title>
            </v-toolbar>

            <v-list two-line>
              <template v-for="(badge, index) in badges">
                <v-list-tile
                  :key="badge.name"
                  avatar
                  ripple
                  @click="editBadge(badge)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ badge.name }}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon
                      color="grey lighten-1"
                    >
                      mdi-pencil
                    </v-icon>

                  </v-list-tile-action>

                </v-list-tile>
                <v-divider
                  v-if="index + 1 < badges.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="dialog = !dialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="badge.id">Edit Badge</v-toolbar-title>
          <v-toolbar-title v-else>Add Badge</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="badge.id > 0" dark flat @click="updateBadge">Update</v-btn>
            <v-btn v-else dark flat @click="saveBadge">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="badge.name"
                  label="Badge Name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data: () => ({
    currentPage: 'Settings',
    userId: 0,
    dialog: false,
    // myId: this.$store.state.user.id,
    isAdmin: false,
    badges: [],
    badge: {},
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.isAdmin = this.$store.state.isAdmin
    this.userId = this.$store.state.user.id

    this.getBadges()
  },

  watch: {
    dialog (val) {
      if (!val) {
        this.badge = {}
      }
    }
  },

  methods: {
    async getBadges () {
      try {
        const response = await Api().get('badges')
        this.badges = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    editBadge (badge) {
      this.badge = badge
      this.dialog = true
    },

    async saveBadge () {
      try {
        const response = await Api().post('badges', this.badge)

        this.getBadges()

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateBadge () {
      try {
        const response = await Api().put('badges', this.badge)

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/settings/Badges.vue